import styled from 'styled-components'

export const IconCheckMarkWrapper = styled.span`
  width: 16px;
  height: 10px;
  margin-right: 8px;
`

export const ColorStyledSpan = styled.span`
  color: #1cb954;
  margin-left: auto;
`

export const CurrencySymbol = styled.div`
  margin-top: -2px;
  color: #646877;
`

export const PlatformsWrapper = styled.div`
  width: 100%;
  display: block;
  border-radius: 5px;
`

export const GenresSelectItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #646877;
`

export const GenresSelectItemAnimation = styled(GenresSelectItem)`
  animation: fade 0.5s ease-in-out;
`

export const LanguagesSelectItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #646877;
`

export const LanguagesSelectItemAnimation = styled(LanguagesSelectItem)`
  animation: fade 0.5s ease-in-out;
  display: flex;
  justify-content: flex-start;
`

export const CenteredBlock = styled.div`
  margin: 0 auto;
`

export const WrapperRelative = styled.div`
  position: relative;
`

export const StyledLabel = styled.div`
  margin-top: -11px;
  margin-right: 26px;
`

export const StyledLabelSpotify = styled.div`
  margin-top: -10px;
  margin-right: 15px;
`

export const StyledDivForIconCheckMark = styled.div`
  width: 16px;
  height: 10px;
  margin-right: 16px;
`

export const WrapperIconOrangeAlert = styled.div`
  margin-right: 8px;
  width: 33px;
`

export const WrapperGreenBtn = styled.div`
  margin: 0 auto 100px;
`

export const MatchingInfoContainer = styled.div`
  display: flex;
  font-display: row;
  color: #f19236;
  align-items: flex-start;
  margin-bottom: 32px;
`

export const MatchingInfoIcon = styled.div`
  margin-right: 8px;
  width: 16px;
  height: 14px;

  & img {
    width: 16px;
    height: 14px;
  }
`
